import * as React from 'react';

import styled from 'styled-components';
import { connect } from 'react-redux';
import SvgIcon from '../SvgIcon';
import { getStreakInfo, streakIcon, StreakInfoProps, StreakType, streakType } from './StreakLogic';
import { FormattedMessage } from 'react-intl';

const streakInfoMessage = (info: StreakInfoProps): any => {
  const messageBase = 'components.StreakInfo';

  if (info.current === 0 && info.longest > 0) {
    return <FormattedMessage id={`${messageBase}.welcome_back`} />;
  }

  if (info.current === 0) {
    return <FormattedMessage id={`${messageBase}.zero`} />;
  }

  if (info.current === 1 && info.longest === 1) {
    return <FormattedMessage id={`${messageBase}.good_start`} />;
  }

  if (info.current === 1 && info.longest > 1) {
    return <FormattedMessage id={`${messageBase}.keep_writing`} />;
  }

  if (info.current >= info.longest) {
    return (
      <FormattedMessage
        id={`${messageBase}.longest_streak`}
        values={{
          n_days: `${info.current}`,
        }}
      />
    );
  } else {
    const diff = info.longest - info.current;
    if (diff < 5 && diff > 0) {
      return (
        <FormattedMessage
          id={`${messageBase}.almost_longest`}
          values={{
            n_days: `${info.current}`,
            diff: `${diff}`,
          }}
        />
      );
    } else {
      return (
        <FormattedMessage
          id={`${messageBase}.streak`}
          values={{
            n_days: `${info.current}`,
          }}
        />
      );
    }
  }
};

const Container = styled.div`
  border: 1px solid ${p => p.theme.color.lightGrey};
  border-radius: ${p => p.theme.borderRadius.default};
  display: flex;
  padding: 1.25em;
  align-items: center;
  justify-content: flex-start;
`;

const Text = styled.span`
  color: ${p => p.theme.color.battleshipGrey};
  padding-left: 15px;
  line-height: 1.5;
`;

const StreakInfoComponent = (props: StreakInfoProps) => {
  const type = streakType(props);
  const message = streakInfoMessage(props);
  const shouldShow = props.current >= props.longest || props.current < 4 || props.longest - props.current < 5;
  if (shouldShow) {
    return (
      <Container>
        {type !== StreakType.none && <SvgIcon iconName={streakIcon(type)} iconWidth={'38px'} iconHeight={'38px'} />}
        <Text>{message}</Text>
      </Container>
    );
  } else {
    return null;
  }
};

export default React.memo(
  connect((state, props) => {
    return {
      ...getStreakInfo(state),
      ...props,
    };
  })(StreakInfoComponent),
);



// WEBPACK FOOTER //
// ./src/components/StreakInfo/index.tsx